import * as SagasType from '../constants/constant_saga_types';
import * as ActionType from '../constants/constant_action_types';

export function fetchSaleTransactionList( silent, filters ) {
  return { type: SagasType.FETCH_LIST_SALE_TRANSACTION, silent, filters };
}

export function getSaleTransaction( id ) {
  return { type: SagasType.GET_SALE_TRANSACTION, id };
}

export function saveSaleTransaction(data) {
  return { type: SagasType.SAVE_SALE_TRANSACTION, data };
}

export function fetchSaleTransactionInventory(payload) {
  return { type: SagasType.FETCH_SALE_TRANSACTION_INVENTORY, payload };
}

export function setSaleTransactionInventory(payload) {
  return { type: ActionType.SET_SALE_TRANSACTION_INVENTORY, payload };
}
